import { Link } from "react-router-dom";
import React, { useRef, useState } from "react";
import styles from "./style/Arcaea.module.css";
import back from "./arcaea/glass.png";
import introduction from "./arcaea/1.jpg";
import m1 from "./arcaea/2.png";
import m2 from "./arcaea/3.png";
import m3 from "./arcaea/4.png";
import m4 from "./arcaea/5.jpg";
import m5 from "./arcaea/6.png";
import s1 from "./arcaea/s1.jpg";
import s2 from "./arcaea/s2.jpg";
import s3 from "./arcaea/s3.jpg";
import s4 from "./arcaea/s4.jpg";
import s5 from "./arcaea/s5.jpg";
import b1 from "./arcaea/b1.jpg";
import b2 from "./arcaea/b2.jpg";
import b3 from "./arcaea/b3.jpg";
import b4 from "./arcaea/b4.jpg";
import b5 from "./arcaea/b5.jpg";
import b6 from "./arcaea/b6.jpg";
import b7 from "./arcaea/b7.jpg";
import b8 from "./arcaea/b8.jpg";
import b9 from "./arcaea/b9.jpg";
import b10 from "./arcaea/b10.jpg";
import GrievousLady from "./arcaea/Grievous Lady.mp3";
import Testify from "./arcaea/Testify.mp3";
import Tempestissimo from "./arcaea/Tempestissimo.mp3";
import PRAGMATISM from "./arcaea/PRAGMATISM -RESURRECTION.mp3";
import Arcahv from "./arcaea/Arcahv.mp3";
import Carousel from "./background.js";
import CharacterGallery from "./character.js";

function SongList(props) {
  return (
    <div className={styles.songCard}>
      <div className={styles.songtop}>
        <div>
          <div className={styles.songtitle}>{props.title}</div>
          <div className={styles.songauthor}>{props.artist}</div>
        </div>
        <img className={styles.songimg} src={props.songimg} />
      </div>
      <audio id="myAudio" src={props.song} controls></audio>
    </div>
  );
}

function Arcaea() {
  const gameDiv = useRef(null);
  const musicDiv = useRef(null);
  const artDiv = useRef(null);
  const gamemenu = useRef(null);
  const musicmenu = useRef(null);
  const artmenu = useRef(null);

  const images = [b1, b2, b3, b4, b5, b6, b7, b8, b9, b10];
  function changetoGame() {
    if (gameDiv.current.style.display == "none") {
      gamemenu.current.style.background = "#ff4593";
      gamemenu.current.style.color = "#fafafa";
      gameDiv.current.style.display = "grid";
      musicDiv.current.style.display = "none";
      artDiv.current.style.display = "none";
      musicmenu.current.style.background = "#fafafa";
      musicmenu.current.style.color = "#030303";
      artmenu.current.style.background = "#fafafa";
      artmenu.current.style.color = "#030303";
    } else {
      gamemenu.current.style.background = "#fafafa";
      gamemenu.current.style.color = "#030303";
      gameDiv.current.style.display = "none";
    }
  }
  function changetoMusic() {
    if (musicDiv.current.style.display == "none") {
      musicmenu.current.style.background = "#ff4593";
      musicmenu.current.style.color = "#fafafa";
      gameDiv.current.style.display = "none";
      musicDiv.current.style.display = "block";
      artDiv.current.style.display = "none";
      gamemenu.current.style.background = "#fafafa";
      gamemenu.current.style.color = "#030303";
      artmenu.current.style.background = "#fafafa";
      artmenu.current.style.color = "#030303";
    } else {
      musicmenu.current.style.background = "#fafafa";
      musicmenu.current.style.color = "#030303";
      musicDiv.current.style.display = "none";
    }
  }
  function changetoArt() {
    if (artDiv.current.style.display == "none") {
      artmenu.current.style.background = "#ff4593";
      artmenu.current.style.color = "#fafafa";
      gameDiv.current.style.display = "none";
      musicDiv.current.style.display = "none";
      artDiv.current.style.display = "block";
      gamemenu.current.style.background = "#fafafa";
      gamemenu.current.style.color = "#030303";
      musicmenu.current.style.background = "#fafafa";
      musicmenu.current.style.color = "#030303";
    } else {
      artmenu.current.style.background = "#fafafa";
      artmenu.current.style.color = "#030303";
      artDiv.current.style.display = "none";
    }
  }

  return (
    <div className={styles.main}>
      <Link to="/games">
        <img src={back} className={styles.menuimg} />
        <p className={styles.menuimg}>Back</p>
      </Link>
      <div className={styles.title}>
        Two young girls explore a shattered world, filled with sound: a past to
        be uncovered...
        <br />
        Each awakens in this blank, ruin-dotted world to discover that she is
        equally blank, remembering nothing of what came before.And then they
        make a second discovery: the Arcaea, multitudes of floating glass-like
        shards containing vivid memories of the past.
      </div>
      <div className={styles.menu}>
        <div className={styles.textblock} ref={gamemenu} onClick={changetoGame}>
          Gameplay
        </div>
        <div
          className={styles.textblock}
          ref={musicmenu}
          onClick={changetoMusic}
        >
          Music
        </div>
        <div className={styles.textblock} ref={artmenu} onClick={changetoArt}>
          Art and story
        </div>
      </div>
      <div className={styles.game} ref={gameDiv}>
        <div className={styles.subtitle}>Introduction</div>
        <div className={styles.text}>
          <strong>Arcaea</strong> is a three-dimensional music game developed by
          Lowiro. The mobile version is available on iOS and Android platforms,
          while the NS version is available on the Nintendo Switch platform. The
          mobile version of the game was released on March 9, 2017, and the NS
          version was launched on May 18, 2021. The game is known for its unique
          3D game mode, with a <strong>partner system</strong> and some partners
          having their own personal <strong>storyline</strong>, which revolves
          around light and opposition. The game has a{" "}
          <strong>world mode</strong> where players can progress by playing
          freely or specifying songs, obtaining elements such as tracks and
          partners. The game comes with a{" "}
          <strong>potential value system</strong> that can calculate information
          about the player's playing history and obtain a numerical value to
          measure their own strength.
        </div>
        <img src={introduction} className={styles.img} />
        <div className={styles.subtitle}>Game mechanics</div>
        <iframe
          src="https://www.youtube.com/embed/UxY0bUxUcFo?si=g-TUYQ1QtOh4CXeL"
          title="YouTube video player"
          frameBorder="0"
        ></iframe>
        <img src={m1} className={styles.img} />
        <img src={m2} className={styles.img} />
        <img src={m3} className={styles.img} />
        <div className={styles.subtitle}>World mode</div>
        <div className={styles.text}>
          World Mode is one of Arcaea's main game modes. Players can progress
          the world by playing tracks in World Mode, earning Ether Drops and
          Fragment rewards, unlocking partners, tracks, and other game content.
          <br />
          The world mode is an online feature, and players need to log in to
          their account to experience it. During the gameplay, they must be
          connected to the internet, otherwise they cannot settle and progress
          the world normally.
          <br />
          There are several <strong>chapters</strong> in the world mode. After
          selecting a chapter to enter, players also need to select an available
          map, and the map icon will display the next attention reward.
          <br />
          After entering the map, there will be several <strong>steps</strong>,
          each with a certain number of steps.
          <br />
          At this point, players can start a world mode game, and after
          settlement, they will receive progress in world mode. They will climb
          up the steps step by step until all the steps on the map are
          completed, <strong>completing this map</strong>.
        </div>
        <img src={m4} className={styles.img} />
        <div className={styles.subtitle}>Potential value</div>
        <div className={styles.text}>
          Potential value, the foundation of mechanisms. It is also one of the
          standard values for measuring the level of players.
          <br />
          The game will calculate the player's potential value based on their
          best performance and recent playing experience. However, due to
          various factors such as the number of tracks owned by the player, the
          difficulty limit of the score, playing style, and recent status, the
          player's true gaming level is not entirely linked to their potential
          value. This number is only used as a reference for the player's
          ability level.
          <br />
          Players can confirm their current potential value at the top of the
          interface. Meanwhile, as the player's potential value changes, the
          background color of the potential value will also change. The specific
          relationship between potential values and background color is shown in
          the table below:
        </div>
        <img src={m5} className={styles.img} />
      </div>
      <div className={styles.music} ref={musicDiv}>
        <SongList
          title="Grievous Lady"
          artist="ARTIST: Laur/Team Grimoire   /   BPM: 105   /   DATE: 2019.10.27"
          song={GrievousLady}
          songimg={s1}
        />
        <SongList
          title="Testify"
          artist="ARTIST: void (Mournfinale)/星熊南巫   /   BPM: 178   /   DATE: 2022.07.22"
          song={Testify}
          songimg={s2}
        />
        <SongList
          title="Tempestissimo"
          artist="ARTIST: t+pazolite   /   BPM: 116   /   DATE: 2022.08.12"
          song={Tempestissimo}
          songimg={s3}
        />
        <SongList
          title="PRAGMATISM-RESURRECTION"
          artist="ARTIST: Laur   /   BPM: 174   /   DATE: 2022.01.01"
          song={PRAGMATISM}
          songimg={s4}
        />
        <SongList
          title="Arcahv"
          artist="ARTIST: Feryquitous   /   BPM: 96   /   DATE: 2020.07.03"
          song={Arcahv}
          songimg={s5}
        />
      </div>
      <div className={styles.art} ref={artDiv}>
        <div className={styles.subtitle}>Background</div>
        <div className={styles.background}>
          <Carousel images={images} />
        </div>
        <div className={styles.text}>
          Under the accompaniment of different songs and even different
          characters, the game background image usually presents different
          scenery, which is one of the major features of Arcaea.
        </div>
        <div className={styles.subtitle}>Characters</div>
        <div className={styles.character}>
          <CharacterGallery />
        </div>
        <div className={styles.subtitle}>Story</div>
        <div className={styles.text}>
          Two young girls explore a shattered world, filled with sound: a past
          to be uncovered...
          <br />
          Each awakens in this blank, ruin-dotted world to discover that she is
          equally blank, remembering nothing of what came before. And then they
          make a second discovery: the Arcaea, multitudes of floating glass-like
          shards containing vivid memories of the past.
          <br />
          <br />
          These shards gather to each girl, as though each is choosing who to be
          experienced by. And each girl, in turn, experiences different
          memories, each in her own way.
          <br />
          <i>
            The glass reflected another world than the one in #fafafa surrounding
            her. In it she could see reflections of seas, cities, fires, lights;
            she rose her hand to scatter them, and laughed in joy.
          </i>
          <br />
          <i>
            She could see glimpses of something else in them, like looking
            through the windows of a train car. In one flash she saw rain, in
            another sunlight, and in another death. She grimaced, and pulled
            away.
          </i>
          <br />
          <br />
          Two young girls, exploring a shattered world, uncovering the past.
          <br />
          One of Light, the other of Conflict.
          <br />
          How will their exploration of this world of Arcaea shape them?
          <br />
          <i>
            A pleasant, simple world like this need only be pleasant. Nothing
            more.
          </i>
          <br />
          <i>
            Wherever it is these shards reflect... she sees little light there.
            Whatever small sparks she sees fade away in an instant.
          </i>
          <br />
          And, at the end of their journeys, who will they have become?
        </div>
      </div>
    </div>
  );
}

export default Arcaea;
